module.exports = __webpack_public_path__ + "img/img5.0ec3f90c.png";